import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export function useJobConstants() {
  const intl = useIntl();

  const getJobType = useCallback(
    (jobType: string | null) => {
      switch (jobType) {
        case 'permanent':
          return intl.formatMessage({
            defaultMessage: 'Permanent',
            description: 'Job type indicating a permanent employment position',
          });
        case 'temporary':
          return intl.formatMessage({
            defaultMessage: 'Temporary',
            description: 'Job type indicating a temporary employment position',
          });
        case 'contract_freelancer':
          return intl.formatMessage({
            defaultMessage: 'Contract',
            description:
              'Job type indicating a contract-based employment position',
          });
        case 'casual':
          return intl.formatMessage({
            defaultMessage: 'Casual',
            description: 'Job type indicating a casual employment position',
          });
        case 'finance_plus_accounting':
          return intl.formatMessage({
            defaultMessage: 'Finance + Accounting',
            description:
              'Job industry category for finance and accounting positions',
          });
        case 'operations_leadership':
          return intl.formatMessage({
            defaultMessage: 'Operations Leadership',
            description:
              'Job industry category for operations leadership positions',
          });
        case 'all_other_administrative_plus_professional':
          return intl.formatMessage({
            defaultMessage: 'All Other Administrative + Professional',
            description:
              'Job industry category for administrative and professional positions not covered by other categories',
          });
        case 'information_technology':
          return intl.formatMessage({
            defaultMessage: 'Information Technology',
            description:
              'Job industry category for information technology positions',
          });
        case 'customer_service_plus_operations':
          return intl.formatMessage({
            defaultMessage: 'Customer Service + Operations',
            description:
              'Job industry category for customer service and operations positions',
          });
        case 'local':
          return intl.formatMessage({
            defaultMessage: 'Local',
            description:
              'Job type for local area positions (e.g., for drivers)',
          });
        case 'regional':
          return intl.formatMessage({
            defaultMessage: 'Regional',
            description:
              'Job type for regional area positions (e.g., for drivers)',
          });
        case 'trainee':
          return intl.formatMessage({
            defaultMessage: 'Trainee',
            description: 'Job type for trainee positions',
          });
        case 'shuttle':
          return intl.formatMessage({
            defaultMessage: 'Shuttle',
            description:
              'Job type for shuttle service positions (e.g., shuttle drivers)',
          });
        default:
          return jobType;
      }
    },
    [intl],
  );

  const getJobHours = useCallback(
    (jobHours: string | null) => {
      switch (jobHours) {
        case 'full_time':
          return intl.formatMessage({
            defaultMessage: 'Full-time',
            description: 'Job hours indicating full-time employment schedule',
          });
        case 'part_time':
          return intl.formatMessage({
            defaultMessage: 'Part-time',
            description: 'Job hours indicating part-time employment schedule',
          });
        default:
          return jobHours;
      }
    },
    [intl],
  );

  return { getJobType, getJobHours };
}
